// extracted by mini-css-extract-plugin
export default {"code":"H_dc"};